package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_11_22_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have requested an audience with Thradoris Fox, the presumed holder of the shard of the Shield of Concar in the Freeburg area. Falorn had spotted a brown-haired person wearing a gray cloak spying on him.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("While the heroes are eating breakfast at The Leaping Ram, a runner arrives and speaks with Lornella, who directs her to the heroes. The runner is a fit human female, bearing a maroon insignia of a half-crown (sundered). She greets the heroes as Cronberry and seeks further information about why they wish to speak with Lord Fox. Caper explains that the Friends of the Forest are also collectors and hope to share stories about their collections. Caper also relays a veiled threat by summarizing how the Friends of the Forest killed the Carnage Crew when they stood in the heroes’ way. Tuesday overshares further about the heroes’ travels. Cranberry has heard of the Duke of Brij (Do’Shara).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn chats with Lornella about the suspicious gray cloaked person he spotted. The spy is likely a member of the Barrowmen, a local thieves guild. The heroes head toward the wharf district to learn more. On the way, Korvis asks Falorn why he is so anxious about people following him, and Falorn catches him up on his history with The Fist and Anarin Conlan. Most of the heroes spot more gray cloaked Barrowmen as they walk. Falorn calls the other heroes to form a tight group around him while he explains a troubling development. He has spotted Ludwig Voss (formerly? of the Carnage Crew) disguised in Barrowmen attire.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper sings loudly in attempt to annoy the Barrowmen. A svelte dwarf approaches Caper and begs her to stop singing. He introduces himself as Harv Barter and tells the heroes that they should speak to Prudence in the Wharf-Side Wicket Inn, if they want to know why the Barrowmen are surveilling them. Caper and Falorn warn Harv about Ludwig Voss.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When the heroes enter the Wharf-Side Wicket Inn, they see Prudence, a sandy blonde haired young woman wearing a frilly dress with leather armor on top. She introduces herself as Prudence Halfwave. She claims that they are “purveyors of information” and that a Halfling asked her to look out of people new to town matching the physical descriptions of the heroes. Tuesday asks Prudence about Ludwig Voss. Falorn pays Prudence 100 gold to look into Ludwig Voss. Korvis, who is perhaps most bothered by the surveilance,  tries to warn Prudence, but it ends up sounding more like a threat. Prudence relents")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("We won’t be following you anymore.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette asks Prudence to describe the organization chart of the Barrowmen. Prudence says that there are several levels of management above her but some people do report to her. Tuesday asks for information about Lord Thradoris Fox at the cost of 100 gold:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("who are his friends and")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("what kind of meetings is he always in?")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn asks Prudence to send a runner with any information she learns, but Prudence rejects this proposal due to safety. She claims that her people could be killed by:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Powerglow Guild: Their people kill without reason.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Shadowstar Mage Guild")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("~~The Gloved Hand (Thieves Guild)~~ The Black Mask (Assassins Guild)")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When the heroes return to the Leaping Ram inn, Lornella hands them a note sealed with “T.F.” that Cronberry delivered while they were in the Wharf district.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Dear Friends of the Forest, Please attend my beautiful bastion. If you are willing to wait, I’d love to receive you. — Thradoris Fox P.S. Arthur was very persuasive.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper asks the group to try to be diplomatic before resorting to violence. Korvis constructs a straw man, arguing that it’s unwise to commit to not defending oneself when an enemy initiates combat.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis suggests the heroes could travel quickly to Lord Thradoris Fox bastion if they used Wind Walk.")
    }
}
